var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var MembershipNode_1, CommitteeMembershipNode_1;
import { Field, ObjectType, registerEnumType } from "type-graphql";
import { CommitteeIdentifier, CommitteeRole, } from "../../authorization/structures.js";
import { Node } from "../relay.js";
import { GlobalIdScalar } from "../scalars/GlobalId.js";
import { TimestampedResource } from "./Resource.js";
export const MembershipPositionType = {
    Member: "Member",
    Captain: "Captain",
};
registerEnumType(MembershipPositionType, {
    name: "MembershipPositionType",
    description: "The position of a member on a team",
});
let MembershipNode = MembershipNode_1 = class MembershipNode extends TimestampedResource {
    id;
    position;
    getUniqueId() {
        return this.id.id;
    }
    text() {
        return this.position;
    }
    static init(init) {
        return MembershipNode_1.createInstance().withValues(init);
    }
};
__decorate([
    Field(() => GlobalIdScalar, { nullable: false }),
    __metadata("design:type", Object)
], MembershipNode.prototype, "id", void 0);
__decorate([
    Field(() => MembershipPositionType, { nullable: false }),
    __metadata("design:type", String)
], MembershipNode.prototype, "position", void 0);
__decorate([
    Field(() => String, { nullable: false }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", String)
], MembershipNode.prototype, "text", null);
MembershipNode = MembershipNode_1 = __decorate([
    ObjectType({
        implements: [Node],
    })
], MembershipNode);
export { MembershipNode };
let CommitteeMembershipNode = CommitteeMembershipNode_1 = class CommitteeMembershipNode extends MembershipNode {
    role;
    identifier;
    text() {
        return `${this.role} of ${this.identifier}`;
    }
    static init(init) {
        return CommitteeMembershipNode_1.createInstance().withValues(init);
    }
};
__decorate([
    Field(() => CommitteeRole, { nullable: false }),
    __metadata("design:type", String)
], CommitteeMembershipNode.prototype, "role", void 0);
__decorate([
    Field(() => CommitteeIdentifier, { nullable: false }),
    __metadata("design:type", String)
], CommitteeMembershipNode.prototype, "identifier", void 0);
__decorate([
    Field(() => String, { nullable: false }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", String)
], CommitteeMembershipNode.prototype, "text", null);
CommitteeMembershipNode = CommitteeMembershipNode_1 = __decorate([
    ObjectType({
        implements: [Node],
    })
], CommitteeMembershipNode);
export { CommitteeMembershipNode };
//# sourceMappingURL=Membership.js.map